
            import "data:text/css,.m-reconnectingIcon-d8302f01d7%7Bwidth:24px;height:24px%7D";
            const result = {"reconnectingIcon":"m-reconnectingIcon-d8302f01d7"};
            export default result;
          